import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SecurityContext
} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

import {TreeNode} from '../tree-select.component';

@Component({
  selector: 'gp-tree-select-node',
  templateUrl: './tree-select-node.html',
  styleUrls: ['./tree-select-node.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreeSelectNodeComponent implements OnChanges {

  @Input()
  public inputValue: string = '';

  @Input()
  public node: TreeNode<any> = null;

  @Input()
  public selectFn: Function;
  @Input()
  public isFiltered: Function;

  @Input()
  public triggerSortByTranslationPipe: boolean = true;

  @Output()
  public isNodeToggle: EventEmitter<TreeNode<any>> = new EventEmitter();

  @Input()
  private expanded: boolean = false;

  constructor(private sanitizer: DomSanitizer) {

  }

  public ngOnChanges() {
    this.node.expanded = this.node.expanded || this.expanded || !!this.inputValue;
  }

  public sanitize(html: string): SafeHtml {
    return this.sanitizer.sanitize(SecurityContext.HTML, html);
  }

  public select() {
    if (this.node.selectable) {
      this.selectFn(this.node.value);
    }
  }

  public toggle(e: Event = void 0) {
    e.stopPropagation();
    e.preventDefault();
    this.node.expanded = !this.node.expanded;
    if (!this.node.expanded) {
      this.collapseNodeChildren(this.node);
    }
    this.isNodeToggle.emit(this.node);
  }

  private collapseNodeChildren(node) {
    node.children.forEach((child: any) => {
      child.expanded = false;
      this.collapseNodeChildren(child);
    });
  }
}
